export default __webpack_public_path__ + "static/media/logo-light.f0a0c9ab.svg";